import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Vendedor } from '../interfaces/vendedor.interface';

@Injectable({
  providedIn: 'root'
})
export class VendedorService {
  private apiUrl = environment.apiNewBackBaseUrl;

  constructor(private http: HttpClient) { }

  getVendedores(): Observable<any> {
    return this.http.post(`${this.apiUrl}OpcionesSolicitud/GetVendedor`, {
      limit: "9999",
      cve_ven: ""
    });
  }

  getTiposVendedor(): Observable<any> {
    return this.http.post(`${this.apiUrl}OpcionesSolicitud/GetOpcionesVariables`, {
      sTabla: "vendedores",
      sCampo: "Tipo",
      iIdioma: 0
    });
  }

  getEstados(): Observable<any> {
    return this.http.post(`${this.apiUrl}CampoTablaWhere/GetCampoTablaWhere`, {
      sTabla: "estados",
      sCampo: "cve_estado"
    });
  }

  createVendedor(vendedor: any): Observable<any> {
    const payload = {
      que: 1,
      tope: "",
      cmd: "",
      cve_ven: vendedor.vendedor || "",
      tipo: vendedor.tipo || "",
      nombre: vendedor.nombre || "",
      calle: vendedor.cedula || "",
      numero_ext: vendedor.exterior || "",
      numero_int: vendedor.interior || "",
      cruzamiento: vendedor.oficinaTramite || "",
      colonia: vendedor.cargo || "",
      ciudad: vendedor.ciudad || "",
      del_muni: vendedor.regional || "",
      cve_estado: vendedor.estado || "",
      cp: vendedor.cp ? Number(vendedor.cp) : 0,
      telefono: vendedor.telefono ? Number(vendedor.telefono) : 0,
      plazo: 0,
      precio: 0,
      zona: "",
      productoPrincipal: "",
      tipoVendedor: "",
      acumulado: 0
    };

    return this.http.post(`${this.apiUrl}Vendedores/cmspa_vendedorAdd`, payload);
  }

  deleteVendedor(cve_ven: string): Observable<any> {
    return this.http.post(`${this.apiUrl}Vendedores/cmspa_vendedorDelete`, {
      que: 3,
      tope: "",
      cmd: "",
      cve_ven: cve_ven,
      tipo: "",
      nombre: "",
      calle: "",
      numero_ext: "",
      numero_int: "",
      cruzamiento: "",
      colonia: "",
      ciudad: "",
      del_muni: "",
      cve_estado: "",
      cp: 0,
      telefono: 0,
      plazo: 0,
      precio: 0,
      zona: "",
      productoPrincipal: "",
      tipoVendedor: "",
      acumulado: 0
    });
  }

  getVendedorDetails(cve_ven: string): Observable<any> {
    return this.http.post(`${this.apiUrl}Vendedores/cmspa_vendedorListDet`, {
      que: 5,
      tope: "",
      cmd: "",
      cve_ven: cve_ven,
      tipo: "",
      nombre: "",
      calle: "",
      numero_ext: "",
      numero_int: "",
      cruzamiento: "",
      colonia: "",
      ciudad: "",
      del_muni: "",
      cve_estado: "",
      cp: 0,
      telefono: 0,
      plazo: 0,
      precio: 0,
      zona: "",
      productoPrincipal: "",
      tipoVendedor: "",
      acumulado: 0
    });
  }

  updateVendedor(vendedor: any): Observable<any> {
    const payload = {
      que: 2,
      tope: "",
      cmd: "",
      cve_ven: vendedor.cve_ven || "",
      tipo: vendedor.tipo || "",
      nombre: vendedor.nombre || "",
      calle: vendedor.calle || "",
      numero_ext: vendedor.numero_ext || "",
      numero_int: vendedor.numero_int || "",
      cruzamiento: vendedor.cruzamiento || "",
      colonia: vendedor.colonia || "",
      ciudad: vendedor.ciudad || "",
      del_muni: vendedor.del_muni || "",
      cve_estado: vendedor.cve_estado || "",
      cp: vendedor.cp ? Number(vendedor.cp) : 0,
      telefono: vendedor.telefono ? Number(vendedor.telefono) : 0,
      plazo: 0,
      precio: 0,
      zona: "",
      productoPrincipal: "",
      tipoVendedor: "",
      acumulado: 0
    };

    return this.http.post(`${this.apiUrl}Vendedores/cmspa_vendedorUpd`, payload);
  }

  getUsuariosDropdown(payload: any): Observable<any> {
    return this.http.post(`${this.apiUrl}UsuarsCS/Getcmspa_usua4V2`, payload);
  }
} 